export default __webpack_public_path__ + "static/media/z010ma0a.b8321223.mp3";